import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function LeftChestLogoDigitizing() {

    const leftSteps = [
        { number: "01", title: "Submit Your Logo", description: "Send your artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Left Chest Digitizing", description: "We convert your design into an embroidery-ready stitch file for small chest placement.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch density, paths, and details for crisp, professional results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Left Chest Logo Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Get accurate left chest logo digitizing services in Los Angeles, CA. Perfect small logo embroidery files for uniforms and apparel." />
                <meta name="keywords" content="left chest logo digitizing, chest logo embroidery digitizing, small logo digitizing, embroidery logo digitizing services, Los Angeles digitizing services, embroidery near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Left Chest Logo Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Left Chest Logo Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/leftchest1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Small Area. Strong Brand Presence.</span>
                                <h3 className="case-study-title">Expert Left Chest Logo Digitizing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in left chest logo digitizing services in Los Angeles, California, providing precise and professional stitch files for small logo placements. Left chest logos are commonly used on uniforms, corporate apparel, and branded clothing, so accuracy and clarity are essential.
                                </p>
                                <p className="case-study-description">
                                    Our team carefully converts your logos into optimized embroidery files, taking into account stitch density, size, and placement to ensure a clean, professional look. Whether your logo has text, symbols, or intricate details, our left chest embroidery digitizing services maintain clarity and visual impact. If you're searching for reliable left chest logo digitizing near you in Los Angeles, Grand Indigo Embroidery delivers high-quality results every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Optimized for Corporate & Uniform Embroidery</span>
                                <h3 className="case-study-title">Custom Digitizing for Uniforms & Apparel</h3>
                                <p className="case-study-description">
                                    Our custom left chest logo digitizing services are tailored for businesses, schools, sports teams, and organizations that require precise small embroidery designs. We optimize each file for your fabric type and garment placement, ensuring minimal thread breaks and smooth execution on all embroidery machines.
                                </p>
                                <p className="case-study-description">
                                    From small logos on shirts and jackets to monograms or symbols, we provide files ready for production. Businesses across Los Angeles trust Grand Indigo Embroidery for accurate, fast, and professional left chest embroidery digitizing. You can also order left chest logo digitizing online and receive your optimized embroidery files quickly.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/leftchest2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={leftSteps} />
                        
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is left chest logo digitizing?"
                                    answer="Left chest logo digitizing is the process of converting small logos for embroidery on the left chest area of garments into machine-readable stitch files."
                                />

                                <FaqItem
                                    question="Do you provide left chest logo digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional left chest logo digitizing services in Los Angeles, California, for local and online clients."
                                />

                                <FaqItem
                                    question="How long does left chest logo digitizing take?"
                                    answer="Most projects are completed within 12–24 hours depending on design complexity."
                                />

                                <FaqItem
                                    question="Can I order left chest logo digitizing online?"
                                    answer="Yes, you can easily order left chest logo digitizing online with fast turnaround and reliable delivery."
                                />

                                <FaqItem
                                    question="What types of garments can use left chest embroidery?"
                                    answer="Left chest embroidery can be applied to shirts, jackets, polos, uniforms, and promotional apparel."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
